module.exports = __webpack_public_path__ + "src/components/Booking/Payment/logo-small.jpg?20c9b885";


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/Payment/logo-small.jpg
// module id = 3078
// module chunks = 8